export const LOAD_TOGGLE = 'LOAD_TOGGLE';


export function toggleLoad(isLoading) {
  return { type: LOAD_TOGGLE , isLoading : isLoading };
}
